import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d35963b")

_pushScopeId("data-v-7d35963b")
const _hoisted_1 = {
  class: "remarks_main",
  id: "detectMan"
}
const _hoisted_2 = { class: "remarks_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "remarks_title" }, "检测师信息", -1)
const _hoisted_4 = { class: "remarks_cnt" }
const _hoisted_5 = {
  key: 0,
  class: "flex-box"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-label" }, "检测师姓名", -1)
const _hoisted_7 = { class: "flex-value" }
const _hoisted_8 = {
  key: 1,
  class: "flex-box"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex-label" }, "报告出具日期", -1)
const _hoisted_10 = { class: "flex-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_ctx.getData('detectManName'))
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.getData('detectManName')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.getData('reportGenDate'))
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.getData('reportGenDate')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})